import React, { useState } from "react";
import Create from './note.jsx';
import Display from './content.jsx';

function  Home(){
    
  const[notes,setNotes]=useState([]); 
  function add(newNote){
   
     setNotes(prevNotes =>{
       return[...prevNotes,newNote];
     })
  } 

function deleteNote(id){
  setNotes( prevNotes =>{
    return prevNotes.filter((noteItem,index)=>{
      return index !== id;
    });
  });
}
   return(
       <div className="main" id="home">
      <h1 className="nothing">heyyy</h1>

           <Create  onAdd={add} />
     
            <div   id="gridblur"  className="container">
        
                { notes.map((noteItem,index)=>{
       
                     return (
                       <div>
                     
                      
                       <Display
                           key={index}
                           id={index}
                           title={noteItem.title}
                           content={noteItem.content}
                           onDelete={deleteNote}
                       />
                        
                      </div>
            
                   );
                  }
                 )
       
               }
            
            </div>
        </div>
   );
}

export default Home;